import { render } from "./AuthenticationTab.vue?vue&type=template&id=1afd6a8b&scoped=true&lang=pug"
import script from "./AuthenticationTab.js?vue&type=script&lang=js&external"
export * from "./AuthenticationTab.js?vue&type=script&lang=js&external"

import "./AuthenticationTab.vue?vue&type=style&index=0&id=1afd6a8b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afd6a8b"]])

export default __exports__